import { Building, Upload, MessageSquare, MapPin, CalendarRange } from "lucide-react";
import { NACIcon } from "@/components/NACIcon";
import { useLocation, Link } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";

const menuItems = [
  { title: "Dashboard Overview", url: "/organization", icon: Building },
  { title: "Update Flight Information", url: "/organization/update-flights", icon: NACIcon },
  { title: "Schedule Import AI", url: "/schedule-tool", icon: CalendarRange },
  { title: "Upload CSV Schedule", url: "/organization/upload-csv", icon: Upload },
  { title: "Announcements", url: "/organization/announcements", icon: MessageSquare },
  { title: "City Management", url: "/organization/cities", icon: MapPin },
  { title: "Aircraft Types", url: "/organization/aircraft-types", icon: NACIcon },
];

export function OrganizationSidebar() {
  const { state } = useSidebar();
  const location = useLocation();
  const collapsed = state === "collapsed";

  const isActive = (path: string) => {
    if (path === "/organization") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Sidebar
      className={`${collapsed ? "w-14" : "w-60"} bg-org-sidebar-bg`}
      collapsible="icon"
    >
      <div className="p-4 border-b border-foreground/20">
        <SidebarTrigger />
      </div>

      <SidebarContent className="bg-org-sidebar-bg">
        <SidebarGroup>
          <SidebarGroupLabel className="text-foreground">Organization</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <Link to={item.url} className="flex items-center gap-2 text-foreground hover:text-foreground">
                      <item.icon className="h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
